import { imageDimensions, type ImageDimensions } from '@eliadmin/core/src/utils/image-dimensions';

// Verified from these exact public CDN assets on 2026-10-09. This is a
// project-only metadata fallback, not a guessed ratio for all product images.
// Evidence: GLOBAL/outputs/performance-wave-2-2026-10-08/spaceplan-web/product-asset-evidence.json.
const verifiedDimensions: Readonly<Record<string, ImageDimensions>> = {
  'https://api.spaceplan.sk/files/act-meetia-odosdesign-33-682x1024-kUusNpX3xASwJG9HxykZ0Kna6gHgW4gLAltiAMzg.jpg?ai=0':
    { width: 682, height: 1024 },
  'https://api.spaceplan.sk/files/img-347-6-eHvTcWtSw6ulcA8nce0JT9ZvlTKIcJzqASHQVEKZ.jpg?ai=0': {
    width: 400,
    height: 400,
  },
};

export function productImageDimensions(image: { url: string; metadata?: unknown }) {
  // Real API metadata wins as soon as it is available. A changed URL never
  // inherits an old image's ratio; unverified assets keep the existing fallback.
  return imageDimensions(image.metadata) ?? verifiedDimensions[image.url];
}
